import {
  createTheme,
  Dialog,
  DialogContent,
  DialogTitle,
  ThemeProvider,
} from "@mui/material";

import { HeaderContainer } from "../../CreateForm/DialogBase/styled";

const theme = createTheme({
  components: {
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          borderBottom: "1px solid lightgrey",
          fontSize: 20,
          fontWeight: 400,
          fontFamily: `"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI",
            "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
            "Helvetica Neue", sans-serif;`,
          padding: "15px 32px",
          marginBottom: "20px",
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: "15px 32px",
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: "15px 32px",
        },
      },
    },
  },
});

export default function PaymentDetailsModal({ isOpen, renderContent }: any) {
  return (
    <ThemeProvider theme={theme}>
      <Dialog open={isOpen} scroll="paper" fullWidth maxWidth="sm">
        <DialogTitle>
          <HeaderContainer>Enter payment Details</HeaderContainer>
        </DialogTitle>
        <DialogContent>{renderContent()}</DialogContent>
      </Dialog>
    </ThemeProvider>
  );
}
